import { Formik } from "formik";
import {
  HeaderSaveFormButton,
  EfsMelcoEfsModelsMapping,
} from "melco-shared-logic";
import { DEFAULT_OUTPUT } from "../../hooks/designMappings/useAddDesignMappingFormSubmit";
import {
  DesignMappingDetailFormValueType,
  useDesignMappingFormSubmit,
} from "../../hooks/designMappings/useDesignMappingFormSubmit";
import { DirtyFormPrompt } from "../form/DirtyFormPrompt";
import { DisplayDesignMappingDetailForm } from "./DisplayDesignMappingDetailForm";

type DesignMappingDetailFormProps = {
  designMapping: EfsMelcoEfsModelsMapping;
};

export const designMappingToInitialValues = (
  designMapping: EfsMelcoEfsModelsMapping
) => {
  const {
    id,
    name,
    global,
    config_type,
    format_id,
    conditions,
    outputs,
    service_type,
    folder_groups,
  } = designMapping;

  const initialValues: DesignMappingDetailFormValueType = {
    id: id ?? "",
    name: name ?? "",
    global,
    config_type,
    format_id: format_id ?? "",
    conditions: conditions ?? [],
    outputs: outputs ?? [DEFAULT_OUTPUT],
    service_type: service_type ?? "",
    folder_groups: folder_groups ?? [],
  };

  return initialValues;
};

export const DesignMappingDetailForm: React.FC<
  DesignMappingDetailFormProps
> = ({ designMapping }) => {
  const onSubmit = useDesignMappingFormSubmit();

  const initialValues = designMappingToInitialValues(designMapping);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validateOnBlur={false}
      validateOnChange={false}
    >
      <DirtyFormPrompt>
        <DisplayDesignMappingDetailForm />

        <HeaderSaveFormButton />
      </DirtyFormPrompt>
    </Formik>
  );
};
